export class PurchasePlan {
  accountNumber: string;
  purchasePlanId: string;
  purchasePlanDescription: string;
  groupingCategory: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/purchase-plan.ts